import { render, staticRenderFns } from "./AscNavigationWrapper.vue?vue&type=template&id=1f45f8b6&"
import script from "./AscNavigationWrapper.vue?vue&type=script&lang=js&"
export * from "./AscNavigationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports